import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import FormContainer from '../../components/FormContainer';
import { toast } from 'react-toastify';
import {
    useGetExpenseDetailsQuery,
    useUpdateExpenseMutation,
} from '../../slices/expensesApiSlice';
import { TextField, Grid } from '@mui/material';

const ExpenseEditScreen = () => {
  const { id: expenseId } = useParams();

  const [name, setName] = useState('');
  const [date, setDate] = useState(new Date());
  const [cost, setCost] = useState(0);
  const [description, setDescription] = useState('');

  const {
    data: expense,
    isLoading,
    refetch,
    error,
  } = useGetExpenseDetailsQuery(expenseId);

  const [updateExpense, { isLoading: loadingUpdate }] =
    useUpdateExpenseMutation();
  const navigate = useNavigate();

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      await updateExpense({
        expenseId,
        name,
        date,
        cost,
        description,
      });
      toast.success('Expense updated');
      refetch();
      navigate('/admin/purchaseslist');
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  useEffect(() => {
    if (expense) {
      setName(expense.name);
      setDate(expense.date)
      setCost(expense.cost);
      setDescription(expense.description);
    }
  }, [expense]);


  return (
    <>
      <Link to='/admin/purchaseslist' className='btn btn-light my-3'>
        Go Back
      </Link>
      <FormContainer>
        <h1>Edit Expense</h1>
        {loadingUpdate && <Loader />}
        {isLoading ? (
          <Loader />
        ) : error ? (
          <Message variant='danger'>{error.data.message}</Message>
        ) : (
          <Form onSubmit={submitHandler}>
             <Grid container spacing={2}>
    <Grid item xs={12}>
      <TextField
        variant="outlined"
        required
        fullWidth
        id="name"
        label="Expense Name"
        name="name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
    </Grid>


    <Grid item xs={12}>
    <TextField
        variant="outlined"
        fullWidth
        id="date"
        label="Date"
        name="date"
        type='Date'
        placeholder='Enter Date'
        value={date}
        onChange={(e) => setDate(e.target.value)}
    />
    </Grid>
    <Grid item xs={12}>
      <TextField
        variant="outlined"
        required
        fullWidth
        id="cost"
        label="Cost"
        name="cost"
        type="number"
        value={cost}
        onChange={(e) => setCost(e.target.value)}
      />
    </Grid>
    <Grid item xs={12}>
    <TextField
        variant="outlined"
        fullWidth
        id="description"
        label="Description"
        name="description"
        type='text'
        placeholder='Enter description'
        value={description}
        onChange={(e) => setDescription(e.target.value)}
    />
    </Grid>
</Grid>
            <Button
              type='submit'
              variant='primary'
              style={{ marginTop: '1rem' }}
            >
              Update
            </Button>
          </Form>
        )}
      </FormContainer>
    </>
  );
};

export default ExpenseEditScreen;